import script from "./Biodefensive.vue?vue&type=script&setup=true&lang=js"
export * from "./Biodefensive.vue?vue&type=script&setup=true&lang=js"

import "./Biodefensive.vue?vue&type=style&index=0&id=f41b974c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f41b974c"]])

export default __exports__